export const getFirstParamValue = (
  query: { [key: string]: string | string[] | undefined },
  key: string,
): string | undefined => {
  const value = query[key]
  return Array.isArray(value) ? value[0] : value
}

export const decorateLinksWithQueryParameters = (
  link: string,
  pageUrl: string,
  urlQueryParameters: Record<string, string>,
): string => {
  const linkUrl = new URL(link, pageUrl)
  Object.entries(urlQueryParameters).forEach(([queryParameter, value]) => {
    linkUrl.searchParams.set(queryParameter, value)
  })
  return linkUrl.toString()
}
